import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { GoogleAnalyticsService } from './google-analytics.service';
import { initializePaddle, Paddle, CheckoutEventNames, getPaddleInstance, PaddleEventData } from '@paddle/paddle-js';
import { PosthogService } from 'src/app/shared/services/posthog.service';

declare var plausible: Function;

interface PaddleCheckoutItem {
  priceId: string;
  quantity: number;
}

interface PaddleCheckoutCustomData extends Record<string, unknown> {
  userId: string;
  planId: string;
  paymentOptionId: string;
}

interface CheckoutPayload {
  isInitialCheckout?: boolean;
  userEmail: string;
  customData: PaddleCheckoutCustomData;
  items: PaddleCheckoutItem[];
  customerId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaddleBillingService {
  private paddle: Paddle;
  private readonly posthogService = inject(PosthogService);
  defaultCallback: (event: PaddleEventData) => void;
  constructor(
    private gaService: GoogleAnalyticsService) {
    this.defaultCallback = ({ data, name }: PaddleEventData) => {
      if (name === CheckoutEventNames.CHECKOUT_COMPLETED) {
        const customData = data.custom_data as Record<string, unknown>;
        const userId = (customData?.userId ?? customData?.user_id) as string | undefined;
        (window as any).fpr('referral', { email: data.customer.email, uid: data.customer.id });
        this.gaService.eventEmitter('conversion', 'AW-477285266/NszrCNCzhrUYEJKXy-MB');
        userId ? plausible('Upgrade', { props: { UID: userId } }) : plausible('Upgrade');
        this.posthogService.client.capture('upgrade');
      }
    }
  }

  async initialize() {
    this.paddle = await initializePaddle({
      debug: false,
      token: environment.paddleBillingToken,
      environment: environment.isPaddleSandbox ? 'sandbox' : 'production',
      checkout: {
        settings: {
          successUrl: environment.dashboardUrl + environment.paddleSuccessRoute
        }
      },
      eventCallback: this.defaultCallback
    });
    this.paddle = getPaddleInstance('v1');
  }

  async checkout({ items, userEmail, customerId, customData, isInitialCheckout }: CheckoutPayload) {
    try {
      if (isInitialCheckout) {
        this.paddle.Update({
          eventCallback: this.defaultCallback
        })
      } else {
        this.paddle.Update({
          eventCallback: () => { }
        })
      }
    } catch (e) { }

    this.paddle.Checkout.open({
      items,
      customer: customerId ? { id: customerId } : { email: userEmail },
      customData,
      settings: isInitialCheckout ? {
        variant: 'one-page',
        successUrl: environment.dashboardUrl + environment.paddleSuccessRoute
      } : {
        successUrl: environment.dashboardUrl + '/account/billing'
      }
    });
  }

  async updatePaymentMethod(transactionId: string) {
    try {
      this.paddle.Update({
        eventCallback: () => { }
      })
    } catch (e) { }

    this.paddle.Checkout.open({
      transactionId,
      settings: {
        successUrl: environment.dashboardUrl + '/account/billing'
      }
    })
  }

}
